/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetApiV3ImagesNodesNodeIdPngRequest = {
  nodeId: string;
};

/** @internal */
export const GetApiV3ImagesNodesNodeIdPngRequest$inboundSchema: z.ZodType<
  GetApiV3ImagesNodesNodeIdPngRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  node_id: z.string(),
}).transform((v) => {
  return remap$(v, {
    "node_id": "nodeId",
  });
});

/** @internal */
export type GetApiV3ImagesNodesNodeIdPngRequest$Outbound = {
  node_id: string;
};

/** @internal */
export const GetApiV3ImagesNodesNodeIdPngRequest$outboundSchema: z.ZodType<
  GetApiV3ImagesNodesNodeIdPngRequest$Outbound,
  z.ZodTypeDef,
  GetApiV3ImagesNodesNodeIdPngRequest
> = z.object({
  nodeId: z.string(),
}).transform((v) => {
  return remap$(v, {
    nodeId: "node_id",
  });
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3ImagesNodesNodeIdPngRequest$ {
  /** @deprecated use `GetApiV3ImagesNodesNodeIdPngRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3ImagesNodesNodeIdPngRequest$inboundSchema;
  /** @deprecated use `GetApiV3ImagesNodesNodeIdPngRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3ImagesNodesNodeIdPngRequest$outboundSchema;
  /** @deprecated use `GetApiV3ImagesNodesNodeIdPngRequest$Outbound` instead. */
  export type Outbound = GetApiV3ImagesNodesNodeIdPngRequest$Outbound;
}

export function getApiV3ImagesNodesNodeIdPngRequestToJSON(
  getApiV3ImagesNodesNodeIdPngRequest: GetApiV3ImagesNodesNodeIdPngRequest,
): string {
  return JSON.stringify(
    GetApiV3ImagesNodesNodeIdPngRequest$outboundSchema.parse(
      getApiV3ImagesNodesNodeIdPngRequest,
    ),
  );
}

export function getApiV3ImagesNodesNodeIdPngRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetApiV3ImagesNodesNodeIdPngRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3ImagesNodesNodeIdPngRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetApiV3ImagesNodesNodeIdPngRequest' from JSON`,
  );
}
